import { useEffect } from 'react';
import languageService from '../services/language.js';
import { useUser } from './useUser'
import { useTranslation } from "react-i18next";

export const useLanguage = () => {

    const { switchUserLanguage } = useUser()
    const { i18n,t } = useTranslation();
    const switchLanguage = (language) => {
        setLanguage(language)
            .then(l => {
                switchUserLanguage(l)
            }); 
    }
    useEffect(() => {
        const titleElement = document.querySelector('head title');
        const descriptionElement = document.querySelector('head meta[name="description"]');
        if (descriptionElement) {
            descriptionElement.content =t('home.infoText2');
          }
          if (titleElement) {
            titleElement.innerText = t("home.titulo");
          }
        document.documentElement.lang = i18n.language;
        switchUserLanguage(i18nToApiLanguage(i18n.language))
      }, [i18n.language]);
    const setLanguage = (language) => {

        i18n.changeLanguage(language);

        switch(language){
            case 'es':
                return languageService.setLanguageCastellano();
            case 'en':
                return languageService.setLanguageIngles();
            case 'ca':
                return languageService.setLanguageCatalan();
            case 'ga':
                return languageService.setLanguageGallego();
            case 'eu':
                return languageService.setLanguageEuskera();
            case 'va':
                return languageService.setLanguageValenciano();
            default:
                break;
        }

    }

    function i18nToApiLanguage(language) {
        switch (language) {
            case "es":
                return "es-ES";
            case "en":
                return "EN";
            case "ca":
                return "ca-ES";
            case "ga":
                return "gl-ES";
            case "eu":
                return "eu-ES";
            case "va":
                return "ca-ES-valencia"
            default:
                return "es-ES";
        }
    }

    return { switchLanguage };
}
